const environmentUrls = {
  localhost: [
    { name: 'UAE', url: 'http://localhost:3000', image: 'uae_image' },
    // { name: 'OMAN', url: 'http://localhost:3000/', image: 'oman_flag' },
    {
      name: 'OMAN',
      url: 'https://star-omanstg.brij.tech',
      image: 'oman_flag',
    },
  ],
  test: [
    {
      name: 'UAE',
      url: 'https://starcinemas.nuviotech.co',
      image: 'uae_image',
    },
    {
      name: 'OMAN',
      url: 'https://star-omanstg.brij.tech',
      image: 'oman_flag',
    },
  ],
  live: [
    { name: 'UAE', url: 'https://www.starcinemas.ae', image: 'uae_image' },
    {
      name: 'OMAN',
      url: 'https://www.thecenturycinemas.com',
      image: 'oman_flag',
    },
  ],
};

// const environmentUrls = {

//   localhost: [
//     { name: "UAE", url: "https://starcinemas-newmycinema.brij.tech/", image: "uae_image" },
//     { name: "OMAN", url: "https://star-omanstg.brij.tech/", image: "oman_flag" },
//   ],
// };

export default environmentUrls;
